const DATE_FULL = { weekday: "long", day: "numeric", month: "long", year: "numeric" };
const DATE_SHORT = { day: "numeric", month: "long", year: "numeric" };
const DATE_DAY = { day: "numeric", month: "long" };

export function parseISODate(value) {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const date = new Date(`${match[1]}-${match[2]}-${match[3]}T12:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateLong(value) {
  const date = parseISODate(value);
  if (!date) return "";
  return date.toLocaleDateString("fr-FR", DATE_FULL);
}

export function formatDateRange(start, end) {
  const from = parseISODate(start);
  const to = parseISODate(end || start);
  if (!from) return "";
  if (!to || start === (end || start)) {
    return from.toLocaleDateString("fr-FR", DATE_FULL);
  }
  if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
    return `${from.getDate()} – ${to.toLocaleDateString("fr-FR", DATE_SHORT)}`;
  }
  return `${from.toLocaleDateString("fr-FR", DATE_DAY)} – ${to.toLocaleDateString("fr-FR", DATE_SHORT)}`;
}

export function slotDateLabel(slot) {
  if (!slot) return "";
  return formatDateRange(slot.start_date || slot.session_start, slot.end_date || slot.session_end);
}

export function slotOptionKey(slot) {
  if (!slot?.id) return "";
  return `${slot.id}:${slot.start_date || slot.session_start || ""}`;
}

export function formulaMatchesDuration(formula, rawParam) {
  const param = String(rawParam || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
  if (!param || !formula) return false;

  // Liens CTA parfois passent duration=<formula.id>
  if (formula.id && String(formula.id).toLowerCase() === param) return true;

  const duration = String(formula.duration || "").toLowerCase();
  const kind = String(formula.duration_kind || "").toLowerCase();
  const name = String(formula.name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  // Canonical buckets. "demi-journee" must not fall into "journee".
  const buckets = {
    "10h": ["10h", "demi-journee", "demi journee", "half_day"],
    journee: ["journee", "full_day", "1j"],
    "20h": ["20h", "semaine", "semaine complete", "full_week"],
  };

  const resolveBucket = (token) => {
    if (!token) return null;
    if (buckets[token]) return token;
    for (const [key, values] of Object.entries(buckets)) {
      if (values.includes(token)) return key;
    }
    // Name heuristics (order matters: demi before plain journee)
    if (token.includes("demi") || token.includes("10h") || token.includes("half")) return "10h";
    if (token.includes("semaine") || token.includes("20h") || token.includes("week")) return "20h";
    if (/(^|[^a-z])journee([^a-z]|$)/.test(token) || token === "1j" || token === "full_day") {
      return "journee";
    }
    return null;
  };

  const paramBucket = resolveBucket(param);
  if (!paramBucket) {
    return duration === param || kind === param || name.includes(param);
  }

  const formulaBucket =
    resolveBucket(duration) || resolveBucket(kind) || resolveBucket(name);
  return formulaBucket === paramBucket;
}
